export class PMOTeamLeadModel {
    constructor() {
        this.teamId = "";
        this.employeeId = "";
    }
}
export default class PMOTeamLead extends PMOTeamLeadModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
